<template>
  <div class="main">
  <div v-show="!iframeState">
    <h2 class="article_title">{{articleDetails.title}}</h2>
    <div class="header">
      <span class="cyan">{{articleDetails.mp_name}}</span><!-- @click="wechatPop()" -->
      <span>{{articleDetails.dateline}}</span>
    </div>
    <div class="article_content" v-html="articleDetails.content"></div>
    <div class="content_font">
      <a class="cyan" :href="articleDetails.ori_url" v-show="articleDetails.ori_url!==''&&articleDetails.cover_logo===0">阅读原文</a>
      <span class="cyan" v-show="articleDetails.ori_url!==''&&articleDetails.cover_logo" @click="readerUrl()">阅读原文</span>
      <span v-show="articleDetails.show_read" class="gray">阅读数</span>
      <span v-show="articleDetails.show_read">{{articleDetails.read_count}}</span>
      <span v-show="articleDetails.show_fav" :class="articleDetails.user_fav===1?'cyan':'gray'" @click="pointArticle()">点赞</span>
      <span v-show="articleDetails.show_fav">{{articleDetails.fav_count}}</span>
    </div>
    <div class="message" v-if="articleDetails.reply">
      <div class="msg_title">
        <p class="liuyan">留言</p>
        <p class="line"></p>
      </div>
      <div class="msg_foot title_jx cf">
          <p class="gray">精选留言</p>
          <p class="cyan" @click="words()">留言</p>
      </div>
      <!-- <div style="height:100px"></div> --><!-- 点击留言用改的 -->
      <div class="msg_content">
        <div class="list_msg cf" v-for="(list,index) in replylists">
            <img :src="list.headimgurl" alt="用户头像">
            <div class="information_msg">
              <div class="user_msg">
                <div class="msg_foot cf">
                  <p class="gray">{{list.nickname}}</p>
                  <p v-if="articleDetails.reply_fav"><span :class="list.fav===1?'cyan':'gray'" @click="point(index)">点赞</span>&nbsp;&nbsp;<span class="gray">{{list.fav_count}}</span></p>
                </div>
                <p class="msg_txt">{{list.content}}</p>
                <p class="gray">{{list.dateline}}</p>
              </div>
              <div class="auth_msg" v-show="list.reply_content&&list.reply_content!==''">
                <div class="msg_foot cf">
                  <p class="gray author">作者回复</p>
                  <p v-if="articleDetails.reply_fav"><span :class="list.fav_reply===1?'cyan':'gray'" @click="pointAuthor(index)">点赞</span>&nbsp;&nbsp;<span class="gray">{{list.reply_fav_count}}</span></p>
                </div>
                <p class="msg_txt">{{list.reply_content}}</p>
                <p class="gray">{{list.reply_dateline}}</p>
              </div>
            </div>
        </div>
      </div>
      <div class="footer_msg" v-show="showMore" @click="canMore?showMoreReply():''">{{bottomText}}</div>
    </div>
    <alert-tip v-if="alertStatus" @closeTip="againConfirm()" :alertText="alertText"></alert-tip>
    <!-- 填写留言弹框 -->
   <!--  <el-dialog title="" :visible.sync="pop_msg" width="80%" center>
      <el-input type="textarea" v-model="msg_desc" :rows="6" placeholder="请输入内容" :maxlength="150" resize="none"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="popMsgSure()">确 定</el-button>
      </span>
    </el-dialog> -->

    <div v-show="pop_msg" class="pop_msg_el">
        <p class="cancel" @click="cancel()">X</p>
        <textarea class="pop_syt" v-model="msg_desc" placeholder="请输入内容" :maxlength="150" rows="8" resize="none"></textarea>
        <p class="sure_pop" @click="canSure?popMsgSure():''">确 定</p>
    </div>


     <!-- 微信关注二维码弹框 -->
    <div class="wechatWrap" v-if="isWechat">
      <div class="wechat">
        <div class="wechatPic">
          <img :src="articleDetails.mp_image" alt="">
        </div>
        <!-- <div class="txtTip">
          <p>长按二维码，点击“识别二维码”按钮，关注我们</p>
          <p v-if="wechatInfo&&wechatInfo.keyword!=''">回复关键字“<span>{{wechatInfo.keyword}}</span>”参与当前活动</p>
          <p>（若您已关注仍弹出此页面，则必须要到当前公众号下回复上诉关键字获取活动链接）</p>
        </div> -->
      </div>
    </div>
  </div>
    <!-- 嵌入外部的文章(用于阅读原文) -->
  <div id="scroll-wrapper">
    <iframe v-show="iframeState" id="show-iframe" :style="{'min-height':frameHeight+'px','width':frameWidth+'px'}" frameborder=0 name="showHere" :src="zjxw_url"></iframe>
  </div>

    <!-- <div v-show="iframeState" class="return_newslist">
      <i class="el-icon-back"></i>
      <p @click="return_newslist()">返回新闻列表</p>
    </div> -->
    <div class="return_zjxw_newslist" v-show="show_returen" @click="return_newslist()">
      <img :src="user_return_img" alt="">
    </div>

    <div class="cover" v-if="shade" @click="popWechat()"></div>
  </div>
</template>

<script>

import alertTip from '@/components/alertTip'
import user_header from '@/assets/images/top_pic1.jpg'
import user_return from '@/assets/images/return.png'



export default {
  data () {
    return {
      articleId: '',
      alertStatus:false,
      iframeState:false,
      zjxw_url:'',
      canMore:false,
      cp_isready:false,
      frameHeight:300,
      frameWidth:'100%',
      alertText:'HAO DEdaf大家都是放假撒家都是放假撒家都是放假撒家都是放假撒fjsaldf',
      pop_msg:false,
      replylists:[],
      articleDetails:'',
      user_header_img:user_header,
      user_return_img:user_return,
      // articleSingle_id:'',
      articlQuery:'',
      article_info:{},
      bottomText:'点击加载更多...',
      msg_desc:'',
      accountId:'',
      openUrl:'',
      openVersion:'wx',
      isLoadStatus:0,
      isWechat:false,
      shade:false,
      showMore:false,
      canSure:true,
      show_returen:false,
      pageParams:{
        pageNo: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  created(){
    let _this = this;
    this.articleId = this.$route.query.articleId || ''
    var window_ht = window.innerHeight || 600,
        body_ht = document.body.clientHeight  || 600;
    _this.frameHeight = Math.max(window_ht, body_ht);

    var window_wt = window.innerWidth||600,
        body_wt = document.body.clientWidth||600;
    _this.frameWidth = Math.max(window_wt, body_wt);

    _this.articlQuery=JSON.parse(JSON.stringify(_this.$route.query));
    if (typeof(CP) == 'object' && CP._options && CP._options.is_ready){
      _this.cp_isready = true;
      CP.get_client_info(function (data) {
        if (data.client_code=='zjxw'||data.client_code=='h24'||data.client_code.indexOf("xsb")!==-1) {
          if (!_this.articlQuery.q) {
            _this.show_returen = true;
          }else{
            _this.show_returen = false;
          }
          CP.get_account_id(function (data) {
            _this.accountId = data.account_id;
            _this.initArticle();
          });
        }else{
          _this.initArticle();
        }
      });
    }
  },
  mounted(){
    let vm = this;
    let timer = null;
    let count = 0;
    function doCPaction() {
      let _this = this;
      if (typeof(CP) == 'object' && CP._options && CP._options.is_ready) {
        vm.cp_isready = true;
        clearTimeout(timer);
        CP.is_login(function (data) {
          // CP.tools.writelog('判断是否登录：', data);
          _this.isLoadStatus = data.is_login;
        });
        CP.get_client_info(function (data) {
          if (data.client_code==='zjxw'||data.client_code==='h24'||data.client_code.indexOf("xsb")!==-1) {
            _this.show_returen = true;
            CP.get_account_id(function (data) {
              vm.accountId = data.account_id;
              vm.initArticle();
            });
          }else{
            vm.initArticle();
          }
        });
      } else {
        count++;
        if (count > 10) {
          return ;
        }
        timer = setTimeout(doCPaction, 200);
      }
    }
    if (!vm.cp_isready) {
      timer = setTimeout(doCPaction, 200);
    }

    // document.body.removeEventListener('touchmove',function(e){
    //     event.preventDefault();
    //   },false);
    $('body').css({"position":"initial","height":"auto"});
    let ifram = document.getElementById('show-iframe');
    if (navigator.userAgent.match(/iPad|iPhone/i)) {
      let iframe_box = document.getElementById('scroll-wrapper');
      ifram.setAttribute('scrolling', 'no');
      iframe_box.appendChild(ifram)
    }

  },
  components:{
    alertTip,
  },
  watch: {
    $route(to,from){
      let _this = this;
      _this.initArticle();
    }
  },
  methods:{
    readerUrl(){//嵌入原文链接到iframe
        let _this = this;
        CP.get_client_info(function (data) {
          if (data.client_code==='zjxw'||data.client_code==='h24'||data.client_code.indexOf("xsb")!==-1) {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              _this.zjxw_url = _this.articleDetails.ori_url;
              _this.iframeState = true;
          }else{
             window.location.href=_this.articleDetails.ori_url;
          }
        });
    },
    return_newslist(){
      let _this= this;
      _this.iframeState = false;
      _this.$router.go(-1)
    },
    cancel(){
      let _this = this;
      _this.pop_msg = false;
      _this.shade = false;
    },
    checkStataus(){
      let _this = this;
      if (CP && CP._options.is_ready) {
          CP.is_login(function (data) {
            _this.isLoadStatus = data.is_login;
            if (_this.isLoadStatus=='1') {
              CP.get_account_id(function (data) {
                  // CP.tools.writelog('checkStataus---account_id:', data);
                  _this.accountId = data.account_id;
                  _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'public',
                      subm:'authorizeurl',
                      account_id:_this.accountId,
                      instance_id:_this.articlQuery.instance_id,
                      mp_id:_this.articlQuery.mp_id,
                      article_id: _this.articleId
                      // article_id:_this.articlQuery.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      if (newArr.url!=='') {
                        window.location.href = newArr.url;
                      }
                    }
                  });
              });
            }else{
              CP.show_login(function (data) {
                CP.tools.writelog('show_login', data);
                _this.accountId = data.account_id;
                _this.isLoadStatus = 1;
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'public',
                      subm:'authorizeurl',
                      account_id:_this.accountId,
                      instance_id:_this.articlQuery.instance_id,
                      mp_id:_this.articlQuery.mp_id,
                      article_id: _this.articleId
                      // article_id:_this.articlQuery.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      if (newArr.url!=='') {
                        window.location.href = newArr.url;
                      }
                    }
                });
              });
            }
          });
      }      // _this.pop_msg = true;
    },
    switchClient(client_type){
      let _this = this;
      switch(client_type){
        case 'wx':
          if (_this.articleDetails.app_type===1) {
            if (_this.articleDetails.have_user_info) {
                _this.shade = true;
                _this.pop_msg= true;
            }else{
                window.location.href = _this.openUrl
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'zjxw':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
              _this.shade = true;
              _this.pop_msg= true;
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'h24':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.shade = true;
                _this.pop_msg= true;
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'web':
          _this.shade = true;
          _this.alertText='请在对应的客户端/公众号中打开'
          _this.alertStatus=true;
          break;
        case 'phone_web':
          _this.shade = true;
          _this.alertText='请在对应的客户端/公众号中打开'
          _this.alertStatus=true;
          break;
        default:console.log('default_client_type'+client_type)
      }
    },
    switchClient_point(client_type,pointIndex){
      let _this = this;
      switch(client_type){
        case 'wx':
          if (_this.articleDetails.app_type===1) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritereply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav=newArr.fav_status;
                    }
                });
            }else{
                window.location.href = _this.openUrl
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'zjxw':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritereply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav=newArr.fav_status;
                    }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'h24':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritereply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav=newArr.fav_status;
                    }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'web':
          _this.shade = true;
          _this.alertText='请在对应的客户端/公众号中打开'
          _this.alertStatus=true;
          break;
        case 'phone_web':
          _this.shade = true;
          _this.alertText='请在对应的客户端/公众号中打开'
          _this.alertStatus=true;
          break;
        default:console.log('default_client_type'+client_type)
      }
    },
    switchClient_point_reply(client_type,pointIndex){
      let _this = this;
      switch(client_type){
        case 'wx':
          if (_this.articleDetails.app_type===1) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritemasterreply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].reply_fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav_reply=newArr.fav_status;
                    }
                });
            }else{
                window.location.href = _this.openUrl
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'zjxw':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritemasterreply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].reply_fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav_reply=newArr.fav_status;
                    }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'h24':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                    url:'/activity/api.php',
                    data:{
                      m:'front',
                      subm:'news',
                      action:'favouritemasterreply',
                      reply_id:_this.replylists[pointIndex].id,
                      article_id: _this.articleId
                    },
                    success: function(data) {
                      let newArr = data.data;
                      _this.replylists[pointIndex].reply_fav_count=newArr.fav_count;
                      _this.replylists[pointIndex].fav_reply=newArr.fav_status;
                    }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'web':
          _this.shade = true;
          if (_this.articleDetails.app_type===1) {
            _this.alertText='请在对应的客户端/公众号中打开'
          }else{
            _this.alertText='请在对应的客户端/公众号中打开'
          }
          _this.alertStatus=true;
          break;
        case 'phone_web':
          _this.shade = true;
          if (_this.articleDetails.app_type===1) {
            _this.alertText='请在对应的客户端/公众号中打开'
          }else{
            _this.alertText='请在对应的客户端/公众号中打开'
          }
          _this.alertStatus=true;
          break;
        default:console.log('default_client_type'+client_type)
      }
    },
    switchClient_point_Article(client_type){
      let _this = this;
      switch(client_type){
        case 'wx':
          if (_this.articleDetails.app_type===1) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                  url:'/activity/api.php',
                  data:{
                    m:'front',
                    subm:'news',
                    action:'favourite',
                    article_id: _this.articleId
                  },
                  success: function(data) {
                    let newArr = data.data;
                    _this.articleDetails.fav_count = newArr.fav_count;
                    _this.articleDetails.user_fav=newArr.fav_status;
                  }
                });
            }else{
                window.location.href = _this.openUrl
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'zjxw':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                  url:'/activity/api.php',
                  data:{
                    m:'front',
                    subm:'news',
                    action:'favourite',
                    article_id: _this.articleId
                  },
                  success: function(data) {
                    let newArr = data.data;
                    _this.articleDetails.fav_count = newArr.fav_count;
                    _this.articleDetails.user_fav=newArr.fav_status;
                  }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'h24':
          if (_this.articleDetails.app_type===2) {
            if (_this.articleDetails.have_user_info) {
                _this.Get({
                  url:'/activity/api.php',
                  data:{
                    m:'front',
                    subm:'news',
                    action:'favourite',
                    article_id: _this.articleId
                  },
                  success: function(data) {
                    let newArr = data.data;
                    _this.articleDetails.fav_count = newArr.fav_count;
                    _this.articleDetails.user_fav=newArr.fav_status;
                  }
                });
            }else{
                _this.checkStataus();
            }
          }else{
            _this.shade = true;
            _this.alertText='请在对应的客户端/公众号中打开'
            _this.alertStatus=true;
          }
          break;
        case 'web':
          _this.shade = true;
          if (_this.articleDetails.app_type===1) {
            _this.alertText='请在对应的客户端/公众号中打开'
          }else{
            _this.alertText='请在对应的客户端/公众号中打开'
          }
          _this.alertStatus=true;
          break;
        case 'phone_web':
          _this.shade = true;
          if (_this.articleDetails.app_type===1) {
            _this.alertText='请在对应的客户端/公众号中打开'
          }else{
            _this.alertText='请在对应的客户端/公众号中打开'
          }
          _this.alertStatus=true;
          break;
        default:console.log('default_client_type'+client_type)
      }
    },
    words(){//留言
        let _this = this;
        // _this.pop_msg= true;
        // _this.shade = true;
        if (CP && CP._options.is_ready) {
            CP.get_client_info(function (data) {
              _this.switchClient(data.client_code);
            });
        }
    },
    showMoreReply(){
      let _this = this;
      _this.pageParams.pageNo+=1;
      _this.replyMsg();
    },
    replyMsg(){//留言列表
       let _this = this;
        _this.Get({
          url:'/activity/api.php',
          data:{
            m:'front',
            subm:'news',
            action:'replylist',
            page:_this.pageParams.pageNo,
            limit:_this.pageParams.pageSize,
            article_id: _this.articleId
          },
          success: function(data) {
            let replyDatas = data.data;
            if (replyDatas.page==='1') {
              _this.replylists=[];
            }
            replyDatas.list.forEach(function(item){
              if (item.headimgurl==='') {
                item.headimgurl=_this.user_header_img;
              }
              _this.replylists.push(item);
            });
            // _this.replylists=replyDatas.list;

            var pageSumNo = Math.ceil(replyDatas.count/replyDatas.limit);
            if (pageSumNo>replyDatas.page) {
                _this.showMore = true;
                _this.canMore = true;
                _this.bottomText='点击加载更多...'
            }else{
              if (replyDatas.list.length>=1) {
                _this.showMore = true;
                _this.canMore = false;
                _this.bottomText='到底啦';
              }
            }
          }
        });
    },
    popWechat(){
      let _this = this;
      if (_this.isWechat) {
        _this.shade = false;
        _this.isWechat = false;
      }
    },
    loadMore(){
      let _this = this;
      _this.replyMsg();
    },
    initArticle(){//活动文章详情
      let _this = this;
      let initObj = {
        m:'front',
        subm:'news',
        action:'articleinfo',
        account_id:_this.accountId,
        article_id: _this.articleId
      }
      let newInitObj = Object.assign({},initObj,_this.articlQuery);
      _this.Get({
          url:'/activity/api.php',
          data:newInitObj,
          success: function(data) {
            _this.replyMsg();
            _this.articleDetails = data.data;
            _this.openUrl = _this.articleDetails.url;
            window.document.title = _this.articleDetails.title || '新闻活动专题';
            let nowUrl = window.location.href;
            if (CP && CP._options.is_ready){
                CP.set_share(function () {}, true, {
                    title: _this.articleDetails.title,
                    shareTo: '',
                    link: nowUrl,
                    imgUrl:_this.articleDetails.cover_image,
                    shareSummary: _this.articleDetails.desc,
                    id: '112',
                    type: 7,
                    datatype: 'link',
                    dataUrl: '',
                    'shareUrlScheme': ''
              });
            }

          }
      });
    },
    popMsgSure(){//提交留言
      let _this = this;
      _this.canSure=false;
      if(_this.msg_desc===''){
        _this.$message({
            type: 'error',
            message: '留言不能为空',
            center:true
        });
        _this.canSure=true;
      }else{
          _this.ajaxPost({
            url:'/activity/api.php',
            data:{
              m:'front',
              subm:'news',
              action:'reply',
              content:_this.msg_desc,
              article_id: _this.articleId
            },
            success: function(data) {
              _this.pop_msg = false;
              _this.shade  = false;
              _this.msg_desc = '' ;
              _this.canSure=true;
              let newArr = data.data;
              if (newArr.headimgurl==='') {
                newArr.headimgurl=_this.user_header_img;
              }
              _this.shade = true;
              if (newArr.status===1) {
                _this.alertText='提交成功！'
                _this.replylists.unshift(newArr);
              }
              if (newArr.status===2) {
                _this.alertText='提交成功,审核后方可显示信息！'
              }
              _this.alertStatus=true;
            },
            error:function(data){
              _this.canSure=true;
            }
        });
      }

    },
    point(pointIndex){//对留言点赞
        let _this = this;
        if (CP && CP._options.is_ready) {
            CP.get_client_info(function (data) {
              _this.switchClient_point(data.client_code,pointIndex);
            });
        }
    },
    pointAuthor(pointIndex){//对留言回复点赞
      let _this = this;
      if (CP && CP._options.is_ready) {
            CP.get_client_info(function (data) {
              _this.switchClient_point_reply(data.client_code,pointIndex);
            });
        }
    },
    pointArticle(){//对文章点赞
      let _this = this;
      if (CP && CP._options.is_ready) {
            CP.get_client_info(function (data) {
              _this.switchClient_point_Article(data.client_code);
            });
        }
    },
    wechatPop(){//弹出二维码
      let _this = this;
      if (_this.articleDetails.app_type===1) {
        _this.shade = true;
        _this.isWechat = true;
      }
    },
    againConfirm(){//弹框确定
      let _this = this;
      _this.shade = false;
      _this.alertStatus = !_this.alertStatus;

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cover{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.main{
  text-align: left;
}
.header{
  margin: 1rem 1.5rem;
  font-size: 1.2rem;
}
.main h2{
  margin: 0 1.5rem;
}
h2.article_title{
  font-size: 2rem;
  text-align: center;
}
.content_font{
  margin: 1rem 1.5rem;
  font-size: 1.2rem;
  text-align: left;
}
.message{
  padding: 1rem 1.5rem;
  background-color: #f2f2f2;
}
.article_content{
  /*text-align: left;*/
  /*text-indent: 2rem;*/
  margin: 0 1.5rem;
  /*font-size: 1.2rem;*/
  overflow: hidden;
}
.article_content table{
  table-layout: fixed;
}
.msg_title{
  text-align: center;
  margin: 1.5rem 0;
  position: relative;
}
/*.msg_title p{
  display: inline-block;
}*/
.msg_content{
  position: relative;
}
.list_msg{
  position: relative;
  border-bottom: 1px dashed#888;
  padding: 1rem 0;
}
.list_msg:last-child{
  border: none;
}
.list_msg img{
  display: inline-block;
  width: 10%;
  float: left;
  margin-right: 3%;
}
.list_msg .msg_txt{
  margin: 1rem 0;
  font-size:1.2rem;
}
.information_msg{
  display: inline-block;
  width: 87%;
}
.msg_foot p{
  display: inline-block;
}
.msg_foot p:nth-child(2){
  float: right;
}
.auth_msg{
  margin-top: 1.5rem;
}
.author{
  border-left: 3px solid#4886ff;
  padding-left: 0.5rem;
}
.line{
  width: 100%;
  height: 1rem;
  position: absolute;
  border-bottom: 1px dashed#888888
}
.liuyan{
  position: absolute;
  top: 0px;
  z-index: 1;
  left: 50%;
  background-color: #f2f2f2;
  padding: 0.2rem 1rem;
  transform: translateX(-50%);
}
.title_jx{
  margin-top: 15%;
}
.wechatWrap{
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2;
    color: #fff;
}
.wechat{
  width: 60%;
  text-align: center;
  margin: 0 auto;
  z-index: 2;
  margin-top: 20%;
}
.pop_msg_el{
    background-color: #fff;
    color: #fff;
    position: fixed;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    width: 80%;
    text-align: center;
    padding: 2rem 0;
    border-radius: 5px;
}
.pop_syt{
  width: 90%;
  border:1px solid#ccc;
  outline: none;
  color: #222;
}
.sure_pop{
  width: 30%;
  margin: 0 auto;
  color: #4886ff;
  text-align: center;
  margin-top: 5%;
  line-height: 2rem;
}
.cancel{
  color: #888;
    text-align: right;
    position: absolute;
    right: 1%;
    top: 1%;
    font-size: 1.2rem;
    width: 20px;
    height: 20px;
    text-align: center;
}
.return_zjxw_newslist{
    width: 30%;
    margin: 0 auto;
    position: fixed;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    z-index: 99;
}
#scroll-wrapper {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/Article.vue